import navigate from '@/utils/navigate';
import percentage from '@/utils/percentage';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import * as React from 'react';

const Component = props => {
    const { complexes, etls, global, other, raws, stopped, total, unused } = props.data;

    return (
        <Card>
            <CardContent sx={{ height: 260 }}>
                <Typography color="text.secondary" gutterBottom sx={{ fontSize: 14 }}>
                    Indicators
                </Typography>
                <Typography component="div" variant="h5">
                    Total: {total}
                </Typography>
                <br/>
                <Typography variant="body2">
                    Raws: {raws} ({percentage(raws, total)})
                    <br/>
                    Complexes: {complexes} ({percentage(complexes, total)})
                    <br/>
                    ETLs: {etls} ({percentage(etls, total)})
                    <br/>
                    Other: {other} ({percentage(other, total)})
                    <br/>
                </Typography>
                <br/>
                <Typography color="text.secondary" sx={{ mb: 0.5 }}>
                    Global: {global}
                    <br/>
                    Stopped: {stopped}
                    <br/>
                    Unused: {unused}
                </Typography>
            </CardContent>
            <CardActions sx={{ height: 20 }}>
                <Button onClick={() => navigate('/indicators')}>View Indicators</Button>
            </CardActions>
        </Card>
    );
};

export default Component;
